import { Redirect, useParams } from "react-router-dom";

import LayoutPage from "layouts/LayoutPage";
import { ReplicaItemType } from "types";
import SectionHeading from "components/SectionHeading";
import StructuredHeading from "components/Replicas/StructuredHeading";
import replicaItems from "assets/replica-items";
import { routes } from "config";
import styled from "styled-components";

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 1100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
`;

const BackgroundImage = styled.div<{ src?: string; opacity?: number }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: -1;

  background: ${(props) =>
    props.src ? `url(${props.src}) center / cover no-repeat` : "none"};

  opacity: ${(props) => props.opacity ?? 0.1};
  filter: blur(3px);
`;

const ReplicaMiscDetail = () => {
  const { id } = useParams();

  let replicaItem: ReplicaItemType | undefined = replicaItems.find(
    (item) => item.id === id,
  );

  if (!replicaItem) {
    // If the item doesn't exist, redirect to replicas main page
    return <Redirect to={"/" + routes.replicas.slug} />;
  }

  // Extract background src and opacity
  const backgroundSrc =
    typeof replicaItem.background === "string"
      ? replicaItem.background
      : replicaItem.background?.src;
  const backgroundOpacity =
    typeof replicaItem.background === "object"
      ? replicaItem.background?.opacity
      : undefined;

  return (
    <LayoutPage>
      <BackgroundImage src={backgroundSrc} opacity={backgroundOpacity} />
      <Wrapper>
        <SectionHeading
          title={
            <StructuredHeading
              nameFormatted={replicaItem.nameFormatted}
              name={replicaItem.name}
            />
          }
          link={`/${routes.replicas.slug}`}
          linkTitle={"Prop Replicas"}
        />

        {replicaItem.page}
      </Wrapper>
    </LayoutPage>
  );
};

export default ReplicaMiscDetail;
